import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { homesteadFeatureFlags } from '../../homesteadFeatureFlags';

/** Registers Homestead's feature flags; Backstage lists them under Settings → Feature Flags. */
export const homesteadFeatureFlagsModule = createFrontendModule({
  pluginId: 'app',
  featureFlags: [...homesteadFeatureFlags],
});
